import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OtpGuard implements CanActivate {
  /**
   * constructor
   * @param router
   */
  constructor(
    private router: Router
  ) { }

  /**
   * canActivate
   * @returns
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkOtpVerification();
  }

  /**
  * checkUserPermission
  * @returns
  */
  checkOtpVerification(): boolean {
    let tokenData = '';
    if(location.href.includes('quote-assessment/submit-missing-info')) {
      tokenData = window.localStorage.getItem('XAuserDetailsExternal');
    } else {
      tokenData = window.localStorage.getItem('XAuserDetails')
    }
    
    let token = '';
    if (tokenData) {
      const data = JSON.parse(tokenData);
      token = data?.idToken;
      if(token){
        return true;
      }
    }
    if(location.href.includes('quote-assessment/submit-missing-info')) this.router.navigateByUrl(`quote-assessment/verify-otp${location.search}`);
    else this.router.navigateByUrl(`claim/verify-otp${location.search}`);
    return false;
  }
}
